module.exports = __webpack_public_path__ + "static/media/image.7654ca70.svg";